import {sumBy} from 'lodash';
import {
  maxSizeAllFilesInMegaBytes,
  maxSizeEachFileInMegaBytes,
} from '../../../common/constants/ftr';

const maxSizeAllFilesInBytes = maxSizeAllFilesInMegaBytes * 1000 * 1024;
const maxSizeEachFileInBytes = maxSizeEachFileInMegaBytes * 1000 * 1024;

export const validateFieldsRequiredInGeneralInformation = (
  actionType,
  generalInfo
) => {
  const isEditMode = actionType !== 'ver';

  if (
    isEditMode &&
    (!generalInfo.chassis ||
      !generalInfo.mileageMeasurement ||
      !generalInfo.mileage ||
      !generalInfo.responsible ||
      (generalInfo.isRepared === 'YES' && !generalInfo.repairOfDate))
  ) {
    return 'Debe llenar todos los campos requeridos';
  }
  return false;
};

export const validateFieldsRequiredInForm = (actionType, answers) => {
  const isEditMode = actionType !== 'ver';

  if (isEditMode && (!answers.cause_of_the_problem || !answers.title)) {
    return 'Debe llenar todos los campos requeridos';
  }
  return false;
};

export const validateAttachmentsSize = (attachments) => {
  const totalSize = sumBy(attachments, 'size');

  if (totalSize > maxSizeAllFilesInBytes) {
    return 'Verifique el tamaño de los archivos adjuntos, excede el tamaño máximo permitido';
  }
  return false;
};

export const processFiles = (attachments) => {
  const formData = new FormData();
  attachments.forEach((element) => {
    if (element.size > maxSizeEachFileInBytes) {
      return;
    }
    formData.append('file', element);
  });
  return formData;
};
